import { useEffect } from 'react'
import { createFileRoute } from '@tanstack/react-router'
import { useShallow } from 'zustand/react/shallow'
import {
  AgentLogin,
  CallIncoming,
  CallOutgoing,
} from '@/components/monitors-route/call-center.jsx'
import useMonitorStore from '@/store/monitor-store'
import { sendGetAgentDashBoard } from '@/utils/webrtc_socket.js'
import useCallStore from '@/store/call-store'

export const Route = createFileRoute('/_auth/monitors/call-center')({
  component: CallCenter,
})

function CallCenter() {
  const isSocketConnected = useCallStore((state) => state.isSocketConnected)
  const [callStats, agentsStatusStats] = useMonitorStore(
    useShallow((state) => [state.callStats, state.agentsStatusStats]),
  )

  useEffect(() => {
    sendGetAgentDashBoard()
  }, [isSocketConnected])

  return (
    <div className="grid grid-cols-1 gap-4">
      <AgentLogin data={agentsStatusStats} isLoading={!isSocketConnected} />
      <div className="grid grid-cols-2 gap-4">
        <CallIncoming
          data={callStats?.inbound}
          isLoading={!isSocketConnected}
        />
        <CallOutgoing
          data={callStats?.outbound}
          isLoading={!isSocketConnected}
        />
      </div>
    </div>
  )
}
